"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _useSoldCounter2 = _interopRequireDefault(require("./useSoldCounter"));
var _SoldOut = _interopRequireDefault(require("./SoldOut"));
var _SoldProgressBar = _interopRequireDefault(require("../SoldProgressBar"));
var _HitProvider = require("../provider/HitProvider");
var __jsx = _react["default"].createElement;
var ProductsCounter = function ProductsCounter(props) {
  var progressActive = props.progressActive;
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive;
  var _useSoldCounter = (0, _useSoldCounter2["default"])(),
    sold = _useSoldCounter.sold,
    left = _useSoldCounter.left;
  if (!isActive) {
    return __jsx(_SoldOut["default"], null);
  }
  return progressActive && left < global.__appConfig__.showHitProgressNumber && __jsx(_SoldProgressBar["default"], {
    sold: sold,
    left: left
  });
};
var _default = ProductsCounter;
exports["default"] = _default;